// Single source of truth for what a RealPay InstalmentStatus code means in the
// UI. Mirrors the mapping payment-request's RealPayExecutor.processCallback
// already uses when it turns a RealPay code into our own PaymentStatus, so an
// installment shown here as "Collected" is exactly the one that would have
// moved a payment to PaymentStatus.Succeeded, etc.
// (payment-request/src/services/executors/realpay/realpay.executor.ts:135-159)
export const INSTALMENT_STATUS = {
  S: { label: 'Collected', pillClass: 'collectedPill' },
  A: { label: 'Scheduled', pillClass: 'scheduledPill' },
  R: { label: 'Retrying', pillClass: 'retryingPill' },
  W: { label: 'Processing', pillClass: 'processingPill' },
  I: { label: 'Cancelled', pillClass: 'cancelledPill' }
}

export const getInstalmentStatusMeta = code =>
  INSTALMENT_STATUS[code] || {
    label: code || 'Unknown',
    pillClass: 'unknownPill'
  }

export const CONTRACT_STATUS = {
  A: { label: 'Active', pillClass: 'collectedPill' }
}

export const getContractStatusMeta = code =>
  CONTRACT_STATUS[code] || {
    label: code ? 'Inactive' : 'Unknown',
    pillClass: 'cancelledPill'
  }
